import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../ui/Layout';
import Card from '../ui/Card';
import Button from '../ui/Button';
import './PaymentResultPage.css';
import { Invoice } from '../../domain/entities/Invoice';
import { Recordatorio } from '../../domain/entities/Recordatorio';
import { ApiPaymentRepository } from '../../infrastructure/repositories/ApiPaymentRepository';

const PaymentPendingPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [transactionRef] = useState(`TX${Date.now()}`);
  const transactionDate = new Date().toLocaleDateString('es-CO');
  const state = location.state as {
    invoice?: Invoice;
    recordatorio?: Recordatorio;
    paymentAmount: number;
    isPartialPayment: boolean;
    selectedPaymentMethod: string;
    uuid: string;
    tipo?: string;
  };
  const { paymentAmount, isPartialPayment, selectedPaymentMethod, uuid } = state;
  const isRecordatorio = state.tipo === 'RECORDATORIO';
  const invoice = state.invoice as Invoice;
  const recordatorio = state.recordatorio as Recordatorio;
  
  const paymentRepository = new ApiPaymentRepository();
  
  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleUpdateStatus = async () => {
    try {
      setIsLoading(true);
      //const id = "47b9a362f98444759f35a27f528b2f48";
      const result = await paymentRepository.checkPaymentStatus(uuid);
      console.log("el estado es: " + result.ESTADO);
      switch (result.ESTADO) {
        case 'Aprobada':
          navigate('/payment/success', {
            state: isRecordatorio
              ? { recordatorio, paymentAmount, isPartialPayment, selectedPaymentMethod, tipo: 'RECORDATORIO' }
              : { invoice, paymentAmount, isPartialPayment, selectedPaymentMethod },
            replace: true
          });
          break;
        case 'Rechazada':
          navigate('/payment/failed', {
            state: isRecordatorio
              ? { recordatorio, paymentAmount, isPartialPayment, selectedPaymentMethod, tipo: 'RECORDATORIO' }
              : { invoice, paymentAmount, isPartialPayment, selectedPaymentMethod },
            replace: true
          });
          break;
        default:
          window.location.reload();
          break;
      }
    } catch (error) {
     window.location.reload();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer);
          handleUpdateStatus();
          return 60; // Reiniciar el contador después de llamar al servicio
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  
  return (
    <Layout>
      <div className="payment-result-container">
        <Card className="payment-result-card">
          <div className="payment-result pending">
            <div className="result-icon pending-icon">!</div>
            <h2>Pago en Proceso de verificación</h2>
            <p style={{ textAlign: 'center', margin: '10px 0', fontSize: '1.1em' }}>
              Próxima actualización en: <span style={{ fontWeight: 'bold', color: 'red' }}>{countdown} segundos</span>
            </p>
            
            <div className="transaction-details">
              <p className="reference">Numero de Referencia: <strong>{transactionRef}</strong></p>
              <p>Fecha: {transactionDate}</p>
              <p>{isRecordatorio ? 'Número de Recordatorio de pago' : 'Número de Factura'}: {isRecordatorio ? `RDP${recordatorio.nroRecordatorio}` : invoice.invoiceNumber}</p>
              <p style={{ color: 'red' }}>Valor Pagado: {paymentAmount}</p>
              <p>Estado: <span className="status-pending">Pendiente</span></p>
            </div>
            
            <p className="result-message">
              Su transacción está siendo procesada. 
              Este proceso puede tardar hasta 24 horas hábiles dependiendo de la entidad bancaria.
            </p>
            
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button onClick={handleGoHome} fullWidth>
                Volver al Inicio
              </Button>
              <Button 
                onClick={handleUpdateStatus} 
                fullWidth 
                disabled={isLoading}
              >
                {isLoading ? 'Actualizando...' : 'Actualizar Estado'}
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentPendingPage; 